import { ArkiveringStatusActions, IArkiveringStatusState } from './types'
import { arkiveringStatusActionsTypes } from './actions'

export const initialState: IArkiveringStatusState = {
  data: [],
  error: '',
  loading: false,
  arkivInfo: {},
}

const arkiveringStatusReducer = (
  state = initialState,
  action: ArkiveringStatusActions
): IArkiveringStatusState => {
  switch (action.type) {
    case arkiveringStatusActionsTypes.FETCH:
      return {
        ...state,
        loading: true,
      }
    case arkiveringStatusActionsTypes.FETCH_FAILED:
      return {
        ...state,
        error: action.error,
        loading: false,
      }
    case arkiveringStatusActionsTypes.FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        error: '',
      }
    default:
      return state
  }
}

export default arkiveringStatusReducer
